/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BriefSchema {
    PREZI = 'PREZI',
    PROJECT = 'PROJECT',
    SQUARESPACE = 'SQUARESPACE',
    SQUARESPACE_API = 'SQUARESPACE_API',
    SQUARE_ONLINE_STORE = 'SQUARE_ONLINE_STORE',
}

export enum BriefState {
    DELETED = 'DELETED',
    DRAFT = 'DRAFT',
    LAUNCHED = 'LAUNCHED',
}

export enum DesignerLevel {
    ENTRY = 'ENTRY',
    MID = 'MID',
    TOP = 'TOP',
}

export enum DesignerSource {
    API = 'API',
    CONTACT = 'CONTACT',
    DIRECT = 'DIRECT',
    RECOMMENDED = 'RECOMMENDED',
    UNKNOWN = 'UNKNOWN',
}

export enum PacklaneTimeframe {
    FORTY_EIGHT_HOURS = 'FORTY_EIGHT_HOURS',
    NOT_SURE = 'NOT_SURE',
    ONE_MONTH = 'ONE_MONTH',
    ONE_WEEK = 'ONE_WEEK',
    SPECIFIC_DATES = 'SPECIFIC_DATES',
    TWO_WEEKS = 'TWO_WEEKS',
}

export enum PenaltyState {
    BANNED = 'BANNED',
    FREE = 'FREE',
    SUSPENDED = 'SUSPENDED',
    WARNED = 'WARNED',
}

export enum PreziProjectType {
    BRANDED_PREZI_TEMPLATE = 'BRANDED_PREZI_TEMPLATE',
    CONVERT_CLASSIC_TO_NEXT = 'CONVERT_CLASSIC_TO_NEXT',
    CONVERT_PPT_TO_PREZI = 'CONVERT_PPT_TO_PREZI',
    EDIT_EXISTING_PREZI = 'EDIT_EXISTING_PREZI',
    NEW_CUSTOM_PREZI = 'NEW_CUSTOM_PREZI',
    OTHER = 'OTHER',
}

export enum PreziTimeframe {
    FORTY_EIGHT_HOURS = 'FORTY_EIGHT_HOURS',
    NOT_SURE = 'NOT_SURE',
    ONE_MONTH = 'ONE_MONTH',
    ONE_WEEK = 'ONE_WEEK',
    SPECIFIC_DATES = 'SPECIFIC_DATES',
    TWO_WEEKS = 'TWO_WEEKS',
}

export enum ProjectAgencyType {
    NO = 'NO',
    YES_INTERESTED = 'YES_INTERESTED',
    YES_NOT_INTERESTED = 'YES_NOT_INTERESTED',
}

export enum ProjectReferralType {
    FACEBOOK = 'FACEBOOK',
    FRIEND = 'FRIEND',
    INFLUENCER = 'INFLUENCER',
    INSTAGRAM = 'INSTAGRAM',
    OTHER = 'OTHER',
    PINTEREST = 'PINTEREST',
    PODCAST = 'PODCAST',
    SEARCH = 'SEARCH',
    TWITTER = 'TWITTER',
    USED_BEFORE = 'USED_BEFORE',
    WEBSITE = 'WEBSITE',
    YOUTUBE = 'YOUTUBE',
}

export enum ProjectTimeframe {
    FORTY_EIGHT_HOURS = 'FORTY_EIGHT_HOURS',
    NOT_SURE = 'NOT_SURE',
    ONE_MONTH = 'ONE_MONTH',
    ONE_WEEK = 'ONE_WEEK',
    SPECIFIC_DATES = 'SPECIFIC_DATES',
    TWO_WEEKS = 'TWO_WEEKS',
}

export enum SquareOnlineStoreExistingAssets {
    IMAGES_AND_VISUAL_ASSETS = 'IMAGES_AND_VISUAL_ASSETS',
    LOGO_AND_BRANDING = 'LOGO_AND_BRANDING',
    WEBSITE_AND_PRODUCT_COPY = 'WEBSITE_AND_PRODUCT_COPY',
}

export enum SquareOnlineStoreProjectType {
    MAJOR_CHANGES = 'MAJOR_CHANGES',
    MINOR_CHANGES = 'MINOR_CHANGES',
    NEW_SITE = 'NEW_SITE',
    RECREATE_SITE = 'RECREATE_SITE',
}

export enum SquareOnlineStoreTimeframe {
    FORTY_EIGHT_HOURS = 'FORTY_EIGHT_HOURS',
    NOT_SURE = 'NOT_SURE',
    ONE_MONTH = 'ONE_MONTH',
    ONE_WEEK = 'ONE_WEEK',
    SPECIFIC_DATES = 'SPECIFIC_DATES',
    TWO_WEEKS = 'TWO_WEEKS',
}

export enum SquarespaceApiAssets {
    COPY = 'COPY',
    IMAGES_VIDEO = 'IMAGES_VIDEO',
    LOGO = 'LOGO',
}

export enum SquarespaceApiHandlePayments {
    NO = 'NO',
    YES = 'YES',
}

export enum SquarespaceApiIndustry {
    ACCOUNTING_AND_FINANCIAL = 'ACCOUNTING_AND_FINANCIAL',
    ART_AND_DESIGN = 'ART_AND_DESIGN',
    BEAUTY_AND_PERSONAL_CARE = 'BEAUTY_AND_PERSONAL_CARE',
    COMMUNITY_AND_NONPROFIT = 'COMMUNITY_AND_NONPROFIT',
    ENTERTAINMENT_AND_MEDIA = 'ENTERTAINMENT_AND_MEDIA',
    FASHION = 'FASHION',
    FOOD_AND_DRINK = 'FOOD_AND_DRINK',
    HEALTH_AND_FITNESS = 'HEALTH_AND_FITNESS',
    HOME_AND_LIVING = 'HOME_AND_LIVING',
    INTERIOR_DESIGN = 'INTERIOR_DESIGN',
    LEGAL_SERVICES_AND_ATTORNEYS = 'LEGAL_SERVICES_AND_ATTORNEYS',
    MARKETING_AND_ADVERTISING = 'MARKETING_AND_ADVERTISING',
    MUSIC = 'MUSIC',
    PHOTOGRAPHY = 'PHOTOGRAPHY',
    REAL_ESTATE = 'REAL_ESTATE',
    RETAIL_RESTAURANT_AND_BAR = 'RETAIL_RESTAURANT_AND_BAR',
    TECHNOLOGY = 'TECHNOLOGY',
    TRAVEL_AND_LIFESTYLE = 'TRAVEL_AND_LIFESTYLE',
    WEDDING = 'WEDDING',
}

export enum SquarespaceApiNeeds {
    FINISH_TRIAL_SITE = 'FINISH_TRIAL_SITE',
    MAJOR_CHANGES = 'MAJOR_CHANGES',
    MINOR_CHANGES = 'MINOR_CHANGES',
    NEW_SITE = 'NEW_SITE',
    RECREATE_SITE = 'RECREATE_SITE',
    REDESIGN_SITE = 'REDESIGN_SITE',
    SEO = 'SEO',
}

export enum SquarespaceApiOrganizationSize {
    FIVE_TO_NINE = 'FIVE_TO_NINE',
    ONE = 'ONE',
    TEN_OR_MORE = 'TEN_OR_MORE',
    TWO_TO_FOUR = 'TWO_TO_FOUR',
}

export enum SquarespaceAssets {
    COPY = 'COPY',
    IMAGES_VIDEO = 'IMAGES_VIDEO',
    LOGO = 'LOGO',
}

export enum SquarespaceHandlePayments {
    NO = 'NO',
    YES = 'YES',
}

export enum SquarespaceIndustry {
    ACCOUNTING_AND_FINANCIAL = 'ACCOUNTING_AND_FINANCIAL',
    ART_AND_DESIGN = 'ART_AND_DESIGN',
    BEAUTY_AND_PERSONAL_CARE = 'BEAUTY_AND_PERSONAL_CARE',
    COMMUNITY_AND_NONPROFIT = 'COMMUNITY_AND_NONPROFIT',
    ENTERTAINMENT_AND_MEDIA = 'ENTERTAINMENT_AND_MEDIA',
    FASHION = 'FASHION',
    FOOD_AND_DRINK = 'FOOD_AND_DRINK',
    HEALTH_AND_FITNESS = 'HEALTH_AND_FITNESS',
    HOME_AND_LIVING = 'HOME_AND_LIVING',
    INTERIOR_DESIGN = 'INTERIOR_DESIGN',
    LEGAL_SERVICES_AND_ATTORNEYS = 'LEGAL_SERVICES_AND_ATTORNEYS',
    MARKETING_AND_ADVERTISING = 'MARKETING_AND_ADVERTISING',
    MUSIC = 'MUSIC',
    PHOTOGRAPHY = 'PHOTOGRAPHY',
    REAL_ESTATE = 'REAL_ESTATE',
    RETAIL_RESTAURANT_AND_BAR = 'RETAIL_RESTAURANT_AND_BAR',
    TECHNOLOGY = 'TECHNOLOGY',
    TRAVEL_AND_LIFESTYLE = 'TRAVEL_AND_LIFESTYLE',
    WEDDING = 'WEDDING',
}

export enum SquarespaceNeeds {
    FINISH_TRIAL_SITE = 'FINISH_TRIAL_SITE',
    MAJOR_CHANGES = 'MAJOR_CHANGES',
    MINOR_CHANGES = 'MINOR_CHANGES',
    NEW_SITE = 'NEW_SITE',
    RECREATE_SITE = 'RECREATE_SITE',
    REDESIGN_SITE = 'REDESIGN_SITE',
}

export enum SquarespaceOrganizationSize {
    FIVE_TO_NINE = 'FIVE_TO_NINE',
    ONE = 'ONE',
    TEN_OR_MORE = 'TEN_OR_MORE',
    TWO_TO_FOUR = 'TWO_TO_FOUR',
}

export enum StructuredBriefErrorReason {
    BLANK = 'BLANK',
    INVALID = 'INVALID',
    TOO_LONG = 'TOO_LONG',
    TOO_SHORT = 'TOO_SHORT',
}

export interface PacklaneBriefFieldsInput {
    title?: string | null;
    currency?: string | null;
    profileApproval?: boolean | null;
    description?: string | null;
    industry?: string | null;
    inspirationFiles?: StructuredBriefFileInput[] | null;
    referenceFiles?: StructuredBriefFileInput[] | null;
    inspirationUrls?: (string | null)[] | null;
    budget?: number | null;
    other?: string | null;
    startDate?: any | null;
    endDate?: any | null;
    timeframe?: PacklaneTimeframe | null;
    urls?: (string | null)[] | null;
    usage?: string | null;
    language?: string | null;
}

export interface PreziBriefFieldsInput {
    projectType?: PreziProjectType | null;
    existingPreziUrls?: (string | null)[] | null;
    preziClassicUrls?: (string | null)[] | null;
    title?: string | null;
    profileApproval?: boolean | null;
    description?: string | null;
    industry?: string | null;
    inspirationFiles?: StructuredBriefFileInput[] | null;
    referenceFiles?: StructuredBriefFileInput[] | null;
    powerpointFiles?: StructuredBriefFileInput[] | null;
    inspirationUrls?: (string | null)[] | null;
    budget?: number | null;
    other?: string | null;
    startDate?: any | null;
    endDate?: any | null;
    timeframe?: PreziTimeframe | null;
    urls?: (string | null)[] | null;
    language?: string | null;
}

export interface ProjectBriefFieldsInput {
    title?: string | null;
    agencyType?: ProjectAgencyType | null;
    currency?: string | null;
    profileApproval?: boolean | null;
    description?: string | null;
    industry?: string | null;
    inspirationFiles?: StructuredBriefFileInput[] | null;
    referenceFiles?: StructuredBriefFileInput[] | null;
    inspirationUrls?: (string | null)[] | null;
    budget?: number | null;
    other?: string | null;
    startDate?: any | null;
    endDate?: any | null;
    timeframe?: ProjectTimeframe | null;
    urls?: (string | null)[] | null;
    usage?: string | null;
    language?: string | null;
    referralType?: ProjectReferralType | null;
    referral?: string | null;
    category?: string | null;
}

export interface SquareOnlineStoreBriefFieldsInput {
    language?: string | null;
    title?: string | null;
    projectType?: SquareOnlineStoreProjectType | null;
    description?: string | null;
    urls?: string[] | null;
    referenceFiles?: StructuredBriefFileInput[] | null;
    inspirationFiles?: StructuredBriefFileInput[] | null;
    inspirationUrls?: string[] | null;
    industry?: string | null;
    startDate?: any | null;
    endDate?: any | null;
    timeframe?: SquareOnlineStoreTimeframe | null;
    budget?: number | null;
    profileApproval?: boolean | null;
    other?: string | null;
    existingAssets?: SquareOnlineStoreExistingAssets[] | null;
}

export interface SquarespaceApiBriefFieldsInput {
    title?: string | null;
    industry?: SquarespaceApiIndustry | null;
    needs?: SquarespaceApiNeeds | null;
    description?: string | null;
    handlePayments?: SquarespaceApiHandlePayments | null;
    url?: string | null;
    assets?: SquarespaceApiAssets[] | null;
    inspirationUrls?: (string | null)[] | null;
    timeline?: any | null;
    organizationSize?: SquarespaceApiOrganizationSize | null;
    organizationRole?: string | null;
}

export interface SquarespaceBriefFieldsInput {
    title?: string | null;
    industry?: SquarespaceIndustry | null;
    needs?: SquarespaceNeeds | null;
    description?: string | null;
    handlePayments?: SquarespaceHandlePayments | null;
    url?: string | null;
    assets?: SquarespaceAssets[] | null;
    inspirationUrls?: (string | null)[] | null;
    timeline?: any | null;
    organizationSize?: SquarespaceOrganizationSize | null;
    organizationRole?: string | null;
}

export interface StructuredBriefFieldsInput {
    project?: ProjectBriefFieldsInput | null;
    prezi?: PreziBriefFieldsInput | null;
    squarespaceApi?: SquarespaceApiBriefFieldsInput | null;
    squarespace?: SquarespaceBriefFieldsInput | null;
    squareOnlineStore?: SquareOnlineStoreBriefFieldsInput | null;
    packlane?: PacklaneBriefFieldsInput | null;
}

export interface StructuredBriefFileInput {
    bucket: string;
    key: string;
    previewable: boolean;
    name: string;
    size: number;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
